// import React, { useState, useEffect } from 'react';
// import { Box, TextField, Typography } from '@mui/material';
// import { LoadingButton } from '@mui/lab';
// import Alert from '@mui/material/Alert';
// import { TreeSelect } from 'primereact/treeselect';
// import { api } from '../../../Api';
// import { isBuffer } from 'lodash';

// export default function CategoriesModal({ handleClose, categories, refreshAdmin }) {
//   const [loading, setloading] = useState(false);
//   const [alert, setalert] = useState({ visible: false, message: '' });
//   const [name, setname] = useState('');

//   const [selectedNodeKey, setSelectedNodeKey] = useState(null);

//   function SaveCategory() {
//     const token = localStorage.getItem('token');
//     const myHeaders = new Headers();
//     myHeaders.append('Authorization', `Bearer ${token}`);

//     const formdata = new FormData();

//     categories && formdata.append('id', categories?.key);
//     formdata.append('name', name);
//     selectedNodeKey && formdata.append('parent_id', selectedNodeKey);

//     const requestOptions = {
//       method: 'POST',
//       headers: myHeaders,
//       body: formdata,
//       redirect: 'follow'
//     };

//     setloading(true);

//     fetch(categories ? api.edit_categories : api.add_categories, requestOptions)
//       .then((response) => {
//         if (response.status === 201 || response.status === 200) {
//           return response.text();
//         } else {
//           return response.json().then((result) => {
//             setalert({ visible: true, message: result.error });
//           });
//         }
//       })
//       .then((result) => {
//         const response = JSON.parse(result);
//         refreshAdmin();
//       })
//       .catch((error) => {
//         console.log('error', error);
//       })
//       .finally(() => setloading(false));
//   }

//   const [categoriess, setcategories] = useState([]);

//   function getCategories() {
//     const myHeaders = new Headers();
//     const token = localStorage.getItem('token');
//     myHeaders.append('Authorization', `Bearer ${token}`);

//     let url = api.get_parent_categories;

//     const requestOptions = {
//       method: 'GET',
//       headers: myHeaders,
//       redirect: 'follow'
//     };

//     fetch(url, requestOptions)
//       .then((response) => {
//         if (response.status === 200) {
//           return response.text();
//         } else {
//           throw new Error('Failed to get brands');
//         }
//       })
//       .then((result_) => {
//         const result = JSON.parse(result_);
//         setcategories(result?.data);
//       })
//       .catch((error) => {
//         setcategories([]);
//       })
//       .finally(() => {});
//   }

//   const [sizes, setsizes] = useState([]);

//   function getSizes() {
//     const myHeaders = new Headers();
//     const token = localStorage.getItem('token');
//     myHeaders.append('Authorization', `Bearer ${token}`);

//     let url = api.get_sizes;

//     const requestOptions = {
//       method: 'GET',
//       headers: myHeaders,
//       redirect: 'follow'
//     };

//     fetch(url, requestOptions)
//       .then((response) => {
//         if (response.status === 200) {
//           return response.text();
//         } else {
//           throw new Error('Failed to get brands');
//         }
//       })
//       .then((result_) => {
//         const result = JSON.parse(result_);
//         setsizes(result);
//       })
//       .catch((error) => {
//         console.log(error);
//       })
//       .finally(() => {});
//   }

//   useEffect(() => {
//     if (categories) {
//       setname(categories?.data?.label);
//       categories?.data?.parent_id != '0' && setSelectedNodeKey(categories?.data?.parent_id);
//     }
//     getCategories();
//     getSizes();
//   }, []);

//   return (
//     <Box
//       p={1}
//       mt={2}
//       style={{
//         width: '100%',
//         alignItems: 'center',
//         display: 'flex',
//         flexDirection: 'column'
//       }}
//     >
//       <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
//         {categories ? 'Edit Category' : 'Category'}
//       </Typography>

//       <Box display={'flex'} sx={{ width: '90%', my: 4, flexDirection: 'column' }} appendTo={'self'}>
//         {categoriess.length > 0 && (
//           <TreeSelect
//             appendTo={'self'}
//             value={selectedNodeKey}
//             onChange={(e) => {
//               if (e.value == undefined) {
//                 setSelectedNodeKey(null);
//               } else {
//                 setSelectedNodeKey(e.value);
//               }
//             }}
//             options={categoriess}
//             className="w-full mb-2"
//             placeholder="Select Parent Category"
//             showClear
//             style={{
//               height: 60,
//               alignItems: 'center',
//               paddingLeft: 10,
//               borderRadius: 10
//             }}
//           />
//         )}

//         <TextField
//           id="outlined-error-helper-text"
//           fullWidth
//           label="Category Name"
//           value={name}
//           onChange={(val) => {
//             setname(val.target.value);
//           }}
//           type="text"
//           variant="outlined"
//           display="inline"
//           style={{ marginTop: 5 }}
//         />

//         <Box mt={2}></Box>
//         {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
//       </Box>

//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'flex-end',
//           width: '90%'
//         }}
//       >
//         <LoadingButton
//           disabled={false}
//           loading={loading}
//           sx={{
//             marginRight: 1
//           }}
//           onClick={SaveCategory}
//           color="primary"
//           variant="contained"
//         >
//           Save
//         </LoadingButton>
//         <LoadingButton onClick={handleClose} variant="outlined">
//           Close
//         </LoadingButton>
//       </Box>
//     </Box>
//   );
// }
import React, { useState, useEffect } from 'react';
import { Box, TextField, Typography, Chip } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { TreeSelect } from 'primereact/treeselect';
import Autocomplete from '@mui/material/Autocomplete'; // Import Autocomplete
import { api } from '../../../Api';

export default function CategoriesModal({ handleClose, categories, refreshAdmin }) {
  const [loading, setloading] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [name, setname] = useState('');
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);
  const [selectedSizes, setSelectedSizes] = useState([]); // State for selected sizes
  const [sizes, setsizes] = useState([]);

  const [categoriess, setcategories] = useState([]);

  function getCategories() {
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    let url = api.get_parent_categories;

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to get brands');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setcategories(result?.data);
      })
      .catch((error) => {
        setcategories([]);
      })
      .finally(() => {});
  }

  function SaveCategory() {
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();

    categories && formdata.append('id', categories?.key);
    formdata.append('name', name);
    selectedNodeKey && formdata.append('parent_id', selectedNodeKey);
    let selectedSizesIds = selectedSizes.map((item) => item.id);
    selectedSizes.length > 0 && formdata.append('size_ids', selectedSizesIds.toString());

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    setloading(true);

    fetch(categories ? api.edit_categories : api.add_categories, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.text();
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then((result) => {
        refreshAdmin();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }

  function getSizes() {
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    let url = api.get_sizes;

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to get sizes');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setsizes(result?.data); // Assuming the result is an array of sizes
        let alreadySelected = categories?.data?.sizes?.map((item) => item.id);
        // console.log(alreadySelected, 'ALREADY SELECTED');
        if (categories?.data?.sizes?.length > 0) {
          // let arr = result?.data.map((item) => alreadySelected.includes(item.id));
          let arr = result?.data
            .map((item) => {
              if (alreadySelected.includes(item.id)) {
                return item;
              } else {
                return null;
              }
            })
            .filter((item) => item != null);
          console.log(arr, 'ARRAY CHECKSsssss');
          setSelectedSizes(arr);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    console.log(categories);
    if (categories) {
      setname(categories?.data?.label);
      categories?.data?.parent_id !== '0' && setSelectedNodeKey(categories?.data?.parent_id);
    }
    getCategories();
    getSizes();
  }, []);

  return (
    <Box
      p={1}
      mt={2}
      style={{
        width: '100%',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {categories ? 'Edit Category' : 'Category'}
      </Typography>

      <Box display={'flex'} sx={{ width: '90%', my: 4, flexDirection: 'column' }} appendTo={'self'}>
        <TreeSelect
          appendTo={'self'}
          value={selectedNodeKey}
          onChange={(e) => {
            if (e.value === undefined) {
              setSelectedNodeKey(null);
            } else {
              setSelectedNodeKey(e.value);
            }
          }}
          options={categoriess}
          className="w-full mb-2"
          placeholder="Select Parent Category"
          showClear
          style={{
            height: 60,
            alignItems: 'center',
            paddingLeft: 10,
            borderRadius: 10
          }}
        />

        <TextField
          id="outlined-error-helper-text"
          fullWidth
          label="Category Name"
          value={name}
          onChange={(val) => {
            setname(val.target.value);
          }}
          type="text"
          variant="outlined"
          display="inline"
          style={{ marginTop: 5 }}
        />

        {/* Multi-select for sizes */}
        {sizes.length > 0 && (
          <Autocomplete
            multiple
            options={sizes}
            getOptionLabel={(option) => option.name}
            value={selectedSizes}
            onChange={(event, newValue) => {
              setSelectedSizes(newValue); // Set the selected sizes
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => <Chip label={option.name} {...getTagProps({ index })} />)
            }
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Select Sizes" placeholder="Sizes" />
            )}
            style={{ marginTop: 10 }}
          />
        )}

        {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '90%'
        }}
      >
        <LoadingButton
          disabled={false}
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={SaveCategory}
          color="primary"
          variant="contained"
        >
          Save
        </LoadingButton>
        <LoadingButton onClick={handleClose} variant="outlined">
          Close
        </LoadingButton>
      </Box>
    </Box>
  );
}
